module.exports = __webpack_public_path__ + "img/left_right_layout_7.4d618e1b.jpg";